import type { StatusTone } from '@/components/status-badge';
import type { WaitBand } from './api/support';

/**
 * Urgência de resposta em semáforo (pedido do dono, 04/10/2026): verde no prazo, laranja na
 * atenção, vermelho no crítico — pelos prazos da empresa. As mesmas cores da Visão geral.
 */
export const WAIT_TONE: Record<WaitBand, StatusTone> = {
  OK: 'success',
  ATTENTION: 'warning',
  CRITICAL: 'danger',
};

/** Faixa lateral do item na lista, com os tokens das etiquetas. */
export const WAIT_EDGE: Record<WaitBand, string> = {
  OK: 'border-l-4 border-l-success',
  ATTENTION: 'border-l-4 border-l-warning',
  CRITICAL: 'border-l-4 border-l-destructive',
};
